import excelToCampaignApi from 'common/src/modules/excelToCampaign/excelToCampaign.api';
import {z} from 'zod';
import {ExcelToCampaignAgentToolName} from '../../excelToCampaignAgent.enums';
import {excelColumnSchema} from './findMappingCandidatesTool.schemas';
import findMappingCandidatesWithLLM from './utils/findMappingCandidatesWithLLM';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import {logger} from 'common/src/modules/shared/copilot/utils/logger';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';

const inputSchema = z.object({
  campaignId: z.number(),
  versionId: z.number(),
  excelHeaders: z.array(excelColumnSchema),
});

function findMappingCandidatesTool() {
  async function execute({
    input: {campaignId, versionId, excelHeaders},
    abortSignal,
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const campaignSignals = await excelToCampaignApi.getCampaignSignals({
      campaignId,
      versionId,
    });

    const {mappingCandidates, nonCandidates} = await findMappingCandidatesWithLLM(
      excelHeaders,
      campaignSignals,
      abortSignal,
    );

    logger.log('findMappingCandidates: mappingCandidates', mappingCandidates);
    logger.log('findMappingCandidates: nonCandidates', nonCandidates);

    return toolResult(JSON.stringify(mappingCandidates));
  }

  return tool({
    name: ExcelToCampaignAgentToolName.FindMappingCandidates,
    description:
      'Find candidates for mapping Excel headers to campaign signals based on semantic matching',
    execute,
    displayName: 'Analyzing worksheet',
    inputSchema,
  });
}

export default findMappingCandidatesTool;
